import React from "react"

const APP_KEY = "508282"
const CALLBACK_URL =
	import.meta.env.MODE === "development"
		? "https://d8d1-2001-fb1-77-ac85-5835-a67-c07e-1478.ngrok-free.app/api/aliexpress/callback"
		: "https://app.kopy.app/api/aliexpress/callback"

export const AliexpressAuth = () => {
	return (
		<div>
			<a
				href={`https://api-sg.aliexpress.com/oauth/authorize?response_type=code&force_auth=true&redirect_uri=${encodeURI(CALLBACK_URL)}&client_id=${APP_KEY}`}
			>
				Aliexpress auth
			</a>
		</div>
	)
}
